// extracted by mini-css-extract-plugin
module.exports = {"root":"CardButton_root__9oqlc"};